export default {
    requestInProgress(state) {
        return state.requestsInProgress > 0
    },
    isAuthenticated(state) {
        return state.user && state.user.id && state.user.id.length > 0
    },
    isInitiliazing(state) {
        return state.initialising
    },
    locale(state) {
        return (state.user && state.user.lang) || navigator.language || 'en-GB'
    },
    language(state, getters) {
        return getters.locale.substr(0, getters.locale.indexOf('-'))
    },
    hasAnyEntityPermission(state, getters) {
        return entity => {
            if (!entity || !entity.length) {
                return true
            }
            return getters.isAuthenticated && state.user[entity]
        }
    },
    isAdmin(state) {
        return state.user.isAdmin
    },
    events(state) {
        return state.events
    },
    nextEvent(state) {
        let nextEvent = state.events.find(x => x.isNext)
        return nextEvent ? nextEvent.id : 0
    },
    currentEvent(state) {
        let c = parseInt(state.currentEvent)
        return isNaN(c) ? 0 : state.currentEvent
    },
    currentEventName(state) {
        let c = parseInt(state.currentEvent)
        if (isNaN(c)) return
        let currentEvent = state.events.find(x => x.id === c)
        return currentEvent ? currentEvent.name : console.log('INVALID EVENT ID')
    },
    eventSelection: state => entity => state.eventSelections[entity],
    teams: state => () => {
        return state.teams
    },
    userTeams: (state, getters) => entityName => {
        if (!state.user || !state.user[entityName]) return []
        if (state.user[entityName].all.length) return getters.teams()
        return getters.teams().filter(x => state.user.teams.includes(x.id))
    },
}
